import { render, staticRenderFns } from "./FiltroMunicipiosIBGE.vue?vue&type=template&id=5c5c23c2"
import script from "./FiltroMunicipiosIBGE.vue?vue&type=script&lang=js"
export * from "./FiltroMunicipiosIBGE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports